var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{ref:"globalBackgroundAudio",staticClass:"global-background-audio",attrs:{"data-play":_vm.isPlay ? 1 : 0},on:{"btnClick":_vm.on_play_and_pause}},[(_vm.isPlay)?_c('v-icon',[_vm._v("volume_up")]):_c('v-icon',[_vm._v("volume_off")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }